import { FunnelDatum, ResponsiveFunnel } from '@nivo/funnel'
import { FunnelStepType } from './Funnels'

const FunnelChart = ({ data }: { data: FunnelStepType[] }) => {
    const formattedData = data.map(step => ({
        id: step.id,
        value: step.value,
        label: `${step.label}\n ${step.count} negócios 💰🚀\n`
    }))

    return (
        <div style={{ height: 400 }}>
            <ResponsiveFunnel
                data={formattedData}
                margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
                shapeBlending={0.17}
                colors={{ scheme: 'greens' }}
                borderWidth={10}
                borderColor={{ theme: 'grid.line.stroke' }}
                labelColor={{ from: 'color', modifiers: [['darker', 3]] }}
                enableBeforeSeparators={false}
                enableAfterSeparators={false}
                currentPartSizeExtension={20}
                currentBorderWidth={10}
                motionConfig='wobbly'
                enableLabel={false}
                // Define o texto visível diretamente nas partes do funil
                layers={['separators', 'parts', 'annotations']}
            />
        </div>
    )
}

export default FunnelChart
